@if (variantOption.oneCall) {
  <div class="wrapper">
    <div>
      <boels-product-one-call [disabled]="true"></boels-product-one-call>
    </div>
    @if (variantOption.variantOptionQualifiers) {
      <span>{{ variantOption.variantOptionQualifiers[0].value }}</span>
    }
  </div>
} @else {
  @if (variantOption.variantOptionQualifiers) {
    {{ variantOption.code }} -
    {{ variantOption.variantOptionQualifiers[0].value }}
  }
}
